import { addDoc, serverTimestamp } from "firebase/firestore";
import { auth } from "@/lib/firebase/clientApp";
import { jobsCollection } from "./firestore";
import type { LodProfile } from "@/app/(workspace)/_types/project";

export interface LodBackfillOptions {
  lodProfile?: LodProfile;
  useExtSplats?: boolean;
}

/**
 * 기존 완료 프로젝트에 대해 LoD(.rad) 재생성을 요청.
 *
 * 워커가 `type === "lod_backfill"` 디스크리미네이터로 라우팅하고,
 * 원본 프로젝트(`sourceJobId`)의 `result.lod` 필드를 갱신한다.
 *
 * 백엔드는 idempotent 처리:
 *   - 이미 radPath 있으면 `skipReason: "lod_already_exists"`로 조용히 COMPLETED
 *   - PROCESSING 중이면 `skipReason: "duplicate_processing"`로 COMPLETED
 *   - 30분 이상 stuck 상태는 새 요청이 override
 *
 * 옵션 기본값:
 *   - lodProfile: "fast" (모든 플랜 사용 가능)
 *   - useExtSplats: false (Ultra+ 사용자가 명시적으로 켤 수 있음)
 *
 * 반환: 새 백필 잡의 Firestore 문서 ID (추적용, 구독 대상은 아님 — 원본 프로젝트 watch로 상태 파악)
 */
export async function requestLodBackfill(
  projectId: string,
  options: LodBackfillOptions = {}
): Promise<string> {
  if (!auth.currentUser) {
    throw new Error("User not authenticated");
  }

  const ref = await addDoc(jobsCollection, {
    type: "lod_backfill",
    sourceJobId: projectId,
    status: "PENDING",
    options: {
      lodProfile: options.lodProfile ?? "fast",
      useExtSplats: options.useExtSplats ?? false,
    },
    requestedBy: auth.currentUser.uid,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return ref.id;
}
